import { gql } from "../../../__generated__/gql";

export const GET_ANNOUNCEMENT = gql(`           
query announcement($id:String) { 
  announcement(where: {id: $id}){
    id
    name
    edition {
      id
      timezone
    }
    bands {
       bookingId: id
              showcase
              band {
                id
                name
                description
                imageUrl
                bookings {
                  id
                  startTime
                  endTime
                }
              }
              date
              duration
              stage {
                id
                name
              }
              startTime
              endTime  
    }
    availabilityDate      
  }}
`);

export const CREATE_UPDATE_ANNOUNCEMENT = gql(`
mutation createUpdateAnnouncement($id: String, $editionId: String!, $name: String!, $availabilityDate: String) {
  createUpdateAnnouncement(announcement: {
    availabilityDate: $availabilityDate,
    editionId: $editionId,
    id: $id,
    name: $name
  }) {
    id
    }
}
`);

export const GET_ANNOUNCEMENTS = gql(`
query announcements($editionId: String!) {
  announcements(where: { editionId: { equals: $editionId } }) {
    id
    name
    edition {
      id
    }
    editionId
    availabilityDate
          bands {
            id
        showcase
        band {
          id
          name
          description
          imageUrl
          bookings {
            id
            startTime
            endTime
          }
        }
        date
        duration
        stage {
          name
        }
        startTime
        endTime
        date
        duration
        stage {
          name
        }
        startTime
        endTime
      }    
  }
}
`);

export const DELETE_ANNOUNCEMENT = gql(`
mutation deleteAnnouncement($announcementId: String!) {
  deleteAnnouncement(announcementId: $announcementId) {
    id    
  }
}
`);

// export const GET_EDITION_FOR_EDIT = gql(`
//         query festivalEditionForEdit($id: String!) {
//           festivalEdition(where: {
//             id: $id
//           }) {
//             name
//             year
//             bands {
//               id
//               bookingId: id
//               showcase
//               band {
//                 id
//                 name
//                 description
//                 imageUrl
//                 bookings {
//                   id
//                   startTime
//                   endTime
//                 }
//               }
//               date
//               duration
//               stage {
//                 id
//                 name
//               }
//               startTime
//               endTime
//             }
//             days {
//               id
//               date
//               name
//             }
//           }
//         }
//         `);

export const BOOKING_FRAGMENT = gql(`
             fragment Booking on BandBooking {
  id
              bookingId: id
              showcase
              band {
                id
                name
                description
                imageUrl
                bookings {
                  id
                  startTime
                  endTime
                }
              }
              date
              duration
              stage {
                id
                name
              }
              startTime
              endTime
  
}
  `);
